/**
 * Builds an accessible label for picker components by combining a description with selected text.
 *
 * @param description - Optional header description (e.g., "When an item is added")
 * @param selectedText - Optional selected items text (e.g., "Issue, Pull request", "Backlog")
 * @returns Combined label string in format "description : selectedText", or just the available part
 *
 * @example
 * buildPickerLabel("Set value", "Backlog") // "Set value : Backlog"
 * buildPickerLabel("Set value", "") // "Set value"
 * buildPickerLabel(undefined, "Issue") // "Issue"
 * buildPickerLabel(undefined, undefined) // undefined
 */
export const buildPickerLabel = (description?: string, selectedText?: string): string | undefined => {
  return description ? `${description}${selectedText ? ' : ' : ''}${selectedText}` : selectedText
}
